// @flow
import * as React from 'react';

import { BoostRings, BounceEffect } from '~/components/widgets';
import { DEFAULT_FONT, defineRangeColours, defineRangeValues, getIndexFromTemp, getTempFromIndex } from '../../utils';
import { SpinnerContainer, SpinnerContainerContainer, Wrapper } from './styles';
import { toCelsius, toFarenheit } from '~/core/utils/temperature';

import { noop } from 'lodash/fp';
import Spinner from '../../../spinner/spinner.component';

type Props = {
    aboveColor?: Object,
    belowColor?: Object,
    bgColor?: Object,
    currentTemp: number,
    disabled?: boolean,
    handleChangeTemp?: noop,
    interval: number,
    isBoosting?: boolean,
    isUpdating?: boolean,
    maxTemp: number,
    menuAbove?: boolean,
    metric: string,
    midTemp: { [string]: number } | number,
    minTemp: number,
    mode: string
};

export default class DualSpinnerBase extends React.Component<Props, void> {
    handleChange = (index: number) => {
        const { handleChangeTemp, interval, maxTemp, metric, mode } = this.props;

        if (handleChangeTemp) {
            const maxTempConverted = metric === 'C' ? maxTemp : toFarenheit(maxTemp);
            const temp = getTempFromIndex({
                maxTemp: maxTempConverted,
                interval,
                index
            });
            const platformTemp = metric === 'C' ? temp : toCelsius(temp);
            handleChangeTemp(platformTemp, mode);
        }
    };

    render() {
        const {
            aboveColor,
            bgColor,
            belowColor,
            currentTemp,
            disabled,
            interval,
            isBoosting,
            isUpdating,
            maxTemp,
            menuAbove,
            metric,
            midTemp,
            minTemp,
            mode
        } = this.props;

        const minTempConverted = metric === 'C' ? minTemp : toFarenheit(minTemp);
        const maxTempConverted = metric === 'C' ? maxTemp : toFarenheit(maxTemp);
        let midTempConverted = null;
        let midTempActual = null;

        if (typeof midTemp === 'number') {
            midTempConverted = metric === 'C' ? midTemp : toFarenheit(midTemp);
        } else {
            midTempActual = midTemp[metric];
        }

        const valuesRange = defineRangeValues({
            interval,
            maxTemp: maxTempConverted,
            minTemp: minTempConverted
        });

        const colorsRange =
            aboveColor && belowColor
                ? defineRangeColours({
                      aboveColor,
                      belowColor,
                      interval,
                      maxTemp: maxTempConverted,
                      midTemp: midTempConverted || midTempActual,
                      minTemp: minTempConverted
                  })
                : null;

        const localeTemperature = metric === 'C' ? currentTemp : toFarenheit(currentTemp);
        const currentIndex = getIndexFromTemp({
            interval,
            maxTemp: maxTempConverted,
            minTemp: minTempConverted,
            temp: localeTemperature
        });

        return (
            <Wrapper menuAbove={menuAbove}>
                <SpinnerContainerContainer>
                    <SpinnerContainer>
                        {isBoosting && <BoostRings alternative mode={mode} />}
                        <BounceEffect isWaiting={isUpdating} usePadding>
                            <Spinner
                                bgColor={bgColor}
                                currentIndex={currentIndex}
                                disabled={disabled}
                                font={DEFAULT_FONT}
                                handleChangeIndex={this.handleChange}
                                purpose="Spinner"
                                rangeColors={colorsRange}
                                rangeValues={valuesRange}
                                style={{
                                    borderRadius: '100%',
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    height: '100%',
                                    width: '100%',
                                    outline: 'none'
                                }}
                            />
                        </BounceEffect>
                    </SpinnerContainer>
                </SpinnerContainerContainer>
            </Wrapper>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/widgets/temperature-spinner/dual-color-range/base/index.js